import React from 'react';
import { Offcanvas } from 'react-bootstrap';

export default function SidebarMenu(props) {
	return (
		<Offcanvas
			backdropClassName={props.className}
			className={'Sidebar left ' + props.className} 
			show={ props.isVisible } 
			onHide={ props.onHide }
			autoFocus
			keyboard
			placement={props.placement}
		>
			<Offcanvas.Body>
				{ props.children }
			</Offcanvas.Body>
		</Offcanvas>
	);
}